(function ( $, window, document, undefined ) {

    $.productSlider = function(elem) {
        var base = this;

        base.init = function() {
            base.$elem = $(elem); // product-item
            base.$slider = base.$elem.find('.product-slider');
            base.$sliderList = base.$elem.find('.product-slider-list');
            base.$slides = base.$elem.find('.product-slider-slide');
            base.$image = base.$elem.find('.product-slider-main-image');
            base.$link = base.$elem.find('.js-product-item-link').first();
            base.$arrows = base.$elem.find('.product-slider-arrow');
            base.$prev = base.$arrows.filter('.product-slider-previous');
            base.$next = base.$arrows.filter('.product-slider-next');

            base.slidePos = 0;
            base.slideWidth = base.$slides.first().outerWidth();
            base.moveWidth = base.slideWidth * 2;
            base.sliderWidth = 0;
            base.$slides.each( function(){ base.sliderWidth += $(this).outerWidth(true); });
            base.$slider.width( base.sliderWidth );
            base.maxPos = Math.floor(base.sliderWidth / base.moveWidth);

            base.options = jQuery.extend({}, base.options, base.$elem.data('options'));

            base.initEvents();
            base.checkArrows();
        };

        base.initEvents = function() {
            base.$elem.on('click', base.goToProduct);
            base.$slides.on('mouseover', base.loadImage);
            base.$arrows.on('click', base.moveSlide);
            base.$elem.find('.js-product-item-link').on('click', function(event){
                event.stopPropagation();
                // event.preventDefault();
            })
        };

        base.goToProduct = function() {
            var href = base.$link.attr('href');
            window.location = href;
        }

        base.loadImage = function(event) {
            var $slide = $(this);

            if (!$slide.hasClass('no-image')) {
                base.$image.attr('src', $slide.data('imagesrc'));

                if ($slide.attr('data-url')) {
                    base.$link.attr('href', $slide.data('url'));
                }
            }

            event.preventDefault();
            event.stopPropagation();
            return false;
        };

        base.moveSlide = function(event) {
            event.stopPropagation();
            event.preventDefault();

            var $arrow = $(this);
            if ($arrow.is('.product-slider-previous')) {
                // move left
                base.$next.show();
                base.slidePos--;

                if (base.slidePos == 0) {
                    base.$prev.hide();
                }
            } else {
                // move right
                base.$prev.show();
                base.slidePos++;

                if (base.slidePos >= base.maxPos) {
                    base.$next.hide();
                }
            }

            base.$sliderList.css({
                transform: 'translate(-' + (base.slidePos * base.moveWidth) + 'px)'
            });
        };

        base.checkArrows = function() {
            if (base.sliderWidth < base.moveWidth) {
                base.$arrows.hide();
            }
        };

        base.init();

        return base;
    }

    $.fn.productSlider = function() {
        return this.each(function(index, elem) {
            var $this = $(elem);

            var data = $this.data('product-item');
            if (!data) {
                $this.data('product-item', new $.productSlider(elem));
            }

        }.bind(this));
    }

})( jQuery, window, document );
